// extracted by mini-css-extract-plugin
module.exports = {"Chart_wrapper":"GenericChart_Chart_wrapper__3flY6","Chart_loader":"GenericChart_Chart_loader__1jVpu"};